<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Prestadores de Salud</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">RazonSocial</th>
          <th scope="col">NombreComercial</th>
          <th scope="col">Ruc</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaAct</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="prestador in datosPaginados" :key="prestador.idPrestador">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(prestador.idPrestador)" title="Editar">edit_square</i></td>
          <td>{{prestador.razonSocial}}</td>
          <td>{{prestador.nombreComercial}}</td>
          <td>{{prestador.ruc}}</td>
          <td>{{getFormattedDate(prestador.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(prestador.fechaAct, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deletePrestador(prestador.idPrestador)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idPrestador" class="form-label">Id</label>
                </div>
                <div class="col-2">
                  <div id="idPrestador" class="form-control-plaintext">{{ datoPrestador.idPrestador }}</div>
                </div>
                <div class="col-2">
                  <label for="fechaReg" class="form-label">Fecha Reg</label>
                </div>
                <div class="col-2">                  
                  <div id="fechaReg" class="form-control-plaintext">{{ getFormattedDate(datoPrestador.fechaReg) }}</div>
                </div>
                <div class="col-2">
                  <label for="fechaAct" class="form-label">Fecha Act </label>
                </div>
                <div class="col-2">
                  <div id="fechaAct" class="form-control-plaintext">{{ getFormattedDate(datoPrestador.fechaAct) }}</div>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="razonSocial" class="form-label">RazonSocial</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="razonSocial" name="razonSocial" v-model="datoPrestador.razonSocial" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombreComercial" class="form-label">NombreComercial</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="nombreComercial" name="nombreComercial" v-model="datoPrestador.nombreComercial" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="ruc" class="form-label">Ruc</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="ruc" name="ruc" v-model="datoPrestador.ruc" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarPrestador" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPrestador" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '../../components/Layout.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js'
import dateFormat from '../../modules/dateFormat.js';
//import { format } from 'date-fns';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      prestadors : [],
      datoPrestador : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.prestadors.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwprestadors/nombre/'+this.nombreBusqueda).then(response=>{
          this.prestadors=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.prestadors.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwprestadors').then(response=>{
      this.prestadors=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.prestadors.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'razonSocial'
        ,'nombreComercial'
        ,'ruc'
      ];
      const requiredFieldsText = [
        'razonSocial'
        ,'nombreComercial'
        ,'ruc'
      ];
      return validarForm(this.datoPrestador, requiredFields, requiredFieldsText);
    },
    async guardarPrestador(){
      if(this.validarForm() === 1){
        try {
          await api.post('/prestadors', this.datoPrestador)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Prestador creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPrestador(){
      if(this.validarForm() === 1){
        try {
          await api.post('/prestadors', this.datoPrestador)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Prestador creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoPrestador={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idPrestador){
      this.btnCrear = false
      this.btnEditar= true
      this.modalWindow = true
      if(idPrestador != null){    
           api.get('/vwprestadors/'+idPrestador).then(resp=>{
          this.datoPrestador = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    async deletePrestador (idPrestador) {
      try{
        await api.delete('/prestadors/'+idPrestador)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
